import { on } from 'delegated-events'
import { Swiper, Autoplay } from 'swiper'

Swiper.use([Autoplay])

const slider = document.querySelector('.stories-slider')
const pagination = document.querySelector('.stories-pagination')

const state = {
  swiper: null,
}

const fn = {
  init: () => {
    const numSlides = slider.querySelectorAll('.swiper-slide').length

    if (numSlides < 2) {
      return
    }

    on('click', '.stories-pagination button', fn.handlePagination)

    state.swiper = new Swiper(slider.querySelector('.swiper-container'), {
      slidesPerView: 'auto',
      loopedSlides: numSlides,
      watchSlidesProgress: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      breakpoints: {
        768: {
          spaceBetween: 30,
        },
        1024: {
          spaceBetween: 60,
        },
        1280: {
          spaceBetween: 100,
        },
      },
      on: {
        slideChangeTransitionStart: fn.updatePagination,
      },
    })
  },

  handlePagination: (e) => {
    const slideIndex = e.target.dataset.index - 1
    state.swiper.slideToLoop(slideIndex)
  },

  updatePagination: (swiper) => {
    if (pagination) {
      const index = swiper.realIndex + 1

      pagination.querySelectorAll('.is-active').forEach((x) => x.classList.remove('is-active'))

      pagination.querySelector(`[data-index="${index}"]`).classList.add('is-active')
    }
  },
}

export default {
  can: () => slider,
  run: fn.init,
}
